export default "__VITE_ASSET__BcaPmdNm__"